export default __webpack_public_path__ + "static/media/element_42.b5192fcc.jpg";